// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Kuwait from '../_raw/flag/icon_flag_kuwait.png';

export default () => <img src={Kuwait} alt="Kuwait" />;
